import { Link } from "react-router-dom";
import { ScanFace, ShoppingBag } from "lucide-react";
import { useCart } from "@/lib/cart";

export function Header() {
  const { items } = useCart();
  return (
    <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-xl backdrop-saturate-150 border-b border-black/5">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="group flex items-center gap-2.5" data-testid="header-logo-link">
          <span className="w-10 h-10 bg-[#0055FF] text-white grid place-items-center rounded-lg group-hover:rotate-[-6deg] transition-transform">
            <ScanFace className="w-6 h-6" />
          </span>
          <span className="font-display font-black text-2xl tracking-tighter">GO-CLICK</span>
        </Link>
        <nav className="flex items-center gap-2">
          <Link
            to="/carrinho"
            data-testid="header-cart-link"
            className="relative flex items-center gap-2 h-10 px-4 rounded-md border border-zinc-200 hover:border-zinc-900 transition-colors text-sm font-medium"
          >
            <ShoppingBag className="w-4 h-4" />
            <span className="hidden sm:inline">Carrinho</span>
            {items.length > 0 && (
              <span
                data-testid="header-cart-count"
                className="absolute -top-2 -right-2 min-w-5 h-5 px-1 rounded-full bg-[#0055FF] text-white text-xs grid place-items-center"
              >
                {items.length}
              </span>
            )}
          </Link>
        </nav>
      </div>
    </header>
  );
}
